import { render } from "./open-spots-badge.vue?vue&type=template&id=f2639216"
import script from "./open-spots-badge.vue?vue&type=script&lang=js"
export * from "./open-spots-badge.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__